module.exports = __webpack_public_path__ + "img/checkbox-marked-circle.b482c0c5.svg";